module.exports = __webpack_public_path__ + "img/hosting_thumbnail-600x450.eb5fd750.jpg";